import { formatDate } from '../../../../../../../../common/helpers/date.helpers';

export function InfoPlanRenter(props) {
  const { planLabel, daysRemaining, initialDateRented, firstInstallmentDate, endDate, weeklyValue } = props;

  const renderInfoBlock = (label, value) => (
    <div className="flex flex-col p-3 bg-white rounded-lg shadow-sm border border-gray-100">
      <label className="font-semibold text-sm text-gray-600 mb-1">{label}</label>
      <p className="text-base font-medium text-gray-900">
        {value || <span className="text-gray-400">Não informado</span>}
      </p>
    </div>
  );

  return (
    <section className="bg-yellowPrimary/20 border-l-4 border-yellow-500 p-4 my-4" role="alert">
      <h3 className="font-bold text-lg text-gray-800 mb-2" >Informações do Plano</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {renderInfoBlock("Plano atual", planLabel)}
        {renderInfoBlock("Dias restantes", daysRemaining)}
        {renderInfoBlock("Data da locação", formatDate(initialDateRented))}
        {renderInfoBlock("Data da primeira parcela", formatDate(firstInstallmentDate))}
        {renderInfoBlock("Data final do plano", formatDate(endDate))}
        {renderInfoBlock("Valor da semanal",
          weeklyValue?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))}
      </div>
    </section>
  );
}